app.controller("StudentNewMyProgramController", [
    "$scope", "$q", "StSubject", "Users", "AuthService", "Students", "ProgramService", "StaticData", "FreshModal", "ConfirmModal", "$stateParams", "$state", "toastr", "usSpinnerService",
    function ($scope, $q, StSubject, Users, AuthService, Students, ProgramService, StaticData, FreshModal, ConfirmModal, $stateParams, $state, toastr, usSpinnerService) {
        $scope.student = null;
        $scope.enabled = true;
        $scope.sortType = 'bySemesters';
        $scope.isActive = '';
        $scope.allCredits = 0;
        $scope.show = 0;
        $scope.semester = 'სემესტრი';
        $scope.programCredits = 240;
        $scope.subjectStates1 = [{studentState: 'passed', name: 'ჩაბარებული'}, {studentState: 'failed', name: 'ჩაჭრილი'},
            {studentState: 'current', name: 'მიმდინარე'}];
        $scope.subjectStates2 = [{studentState: 'blocked', name: 'დაბლოკილი'}, {studentState: 'critical', name: 'კრიტიკული'},
            {studentState: 'important', name: 'მნიშვნელოვანი'}, {studentState: 'normal ', name: 'ზოგადი'}];

        loadPage();

        StaticData.getItemsByKey("container_types").then(function (data) {
            $scope.containerTypes = data;
            $scope.subjectTypes = [{name: "ტიპი"}].concat(data);;
            $scope.containerTypesMap = _.keyBy($scope.containerTypes, '_id');
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        $scope.$watch('semester', function (val) {
            filterSubjects();
        }, true);

        $scope.$watch('subNameOrCode', function (val) {
            filterSubjects();
        }, true);

        $scope.selectSemester = function (semester) {
            $scope.semester = semester;
            filterSubjects();
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");

            Students.getProgram().then(function (program) {
                $scope.semesters = ['სემესტრი', 'სემესტრის გარეშე'].concat(_.range(1, program.semesters + 1));
            });

            Students.selectionList().then(function (data) {
                $scope.subjects = data;
                $scope.allCredits = _(data)
                    .filter(function (subject) {
                        return subject.studentState === 'passed'
                    })
                    .sumBy(function (subject) {
                        return subject.credits;
                    });

                filterSubjects();
                usSpinnerService.stop("root");
            });

            $q.all([StSubject.list({
                page: page,
                limit: $scope.itemsPerPage,
                student: ''
            }), StSubject.totals({student:''})]).then(function (data) {
                var totals = data[1];
                $scope.allCredits = _(data[0])
                    .filter(function (subject) {
                        return subject.studentState === 'passed'
                    })
                    .sumBy(function (subject) {
                        return subject.credits;
                    });
                $scope.average = totals.average;
                $scope.gpa = totals.gpa;

                AuthService.getProfiles().then(function (profiles) {
                    $scope.profiles = _(profiles).filter({type: 'student'}).value();
                    $scope.student = _(profiles).filter({type: 'student', state: 'active'}).head();
                    $scope.studentId =$scope.student._id;
                    $scope.studentSemester = $scope.student.info.semester;
                });

                usSpinnerService.stop("root");
                cb();
            });
        }

        function filterSubjects() {
            $scope.filtered = $scope.subjects;
            if ($scope.subNameOrCode) {
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return subject.name.indexOf($scope.subNameOrCode) !== -1
                        || subject.subject.code.indexOf($scope.subNameOrCode) !== -1
                });
            }
            if ($scope.semester !== 'სემესტრი') {
                var check = $scope.semester === 'სემესტრის გარეშე' ? null : $scope.semester;
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return check ? subject.semester === parseInt(check) : !subject.semester;
                });
            }
            $scope.semesterSubjects = _($scope.filtered).groupBy('semester').value();
            $scope.keys = _.keys($scope.semesterSubjects);
        }

        $scope.applyFilter = function () {
            var semester;

            if ($scope.semester == 'სემესტრი') {
            }
            else if ($scope.semester == 'სემესტრის გარეშე') {
                semester = null;
                $scope.semesterSubjects = {null: $scope.semesterSubjects[semester]};
            }
            else {
                semester = $scope.semester;
                $scope.semesterSubjects = {semester: $scope.semesterSubjects[semester]};
            }

            $scope.keys = _.keys($scope.semesterSubjects);
        };

        $scope.selectionSubjectClasses = function (subject) {
            var selectionSubjectClass = '';
            if ($scope.activeSubject == subject._id) {
                return 'blocked-subject active ';
            }
            if (subject.studentState === 'normal') selectionSubjectClass = ' normal-subject ';
            else if (subject.studentState === 'critical') selectionSubjectClass = ' critical-subject ';
            else if (subject.studentState === 'important') selectionSubjectClass = ' important-subject ';
            else if (subject.studentState === 'blocked') selectionSubjectClass = ' blocked-subject ';
            else if (subject.studentState === 'passed') selectionSubjectClass = ' passed-subject-status ';

            return selectionSubjectClass;
        };

        $scope.getInfo = function (subject) {
            var state = subject.studentState;
            if (state === 'blocked' && !subject.blockers) {
                return 'კრედიტების რაოდენობა არ არის გავლილი ' + subject.preCredits;
            }
            if (state === 'blocked' && subject.blockers) {
                var message = 'დაბლოკილია, წინაპირობების გამო:\n';
                for (var i in subject.blockers) {
                    var blocker = subject.blockers[i];
                    message += '"' + blocker.name + '" - ' + blocker.subject.code + '\n';
                }
                return message;
            }
        };

        $scope.showInfo = function (subject) {
            if ($scope.activeSubject == subject._id) {
                $scope.activeSubject = '';
                subject.show = false;
            } else {
                $scope.activeSubject = subject._id;
                subject.show = true;
            }
        };

        $scope.sortSubjects = function (type) {
            if (type == 'bySemesters') {
                $scope.sortType = 'bySemesters';
                $scope.semesterSubjects = _($scope.filtered).groupBy('semester').value();
                $scope.keys = _.keys($scope.semesterSubjects);
            }
            else {
                $scope.sortType = 'byTypes';
                $scope.semesterSubjects = _($scope.filtered).groupBy('type').value();
                $scope.keys = _.keys($scope.semesterSubjects);
            }
        };
    }
]);
